import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { useGetAvailablePayments } from '@/modules/perseo-billing/hooks';
import useCartPayments from '@/sections/cart/hooks/useCartPayments';

import { PaymentLoader } from '../../components';
import { notifyError } from '../../error-handler';
import useCheckGiftCardModals from '../../hooks/use-check-gift-card-modals';
import { isDeviceKiosco } from '../../utils';
import { ErrorFallbackBilling } from '../fallback/billing-error-fallback';
import { PaymentModals } from '../payment-modals/PaymentModals';
import { PaymentSection } from '../payment-section/payment-section.container';

import useGtmEvents from './hooks/use-gtm-events';
import { SummaryContainer } from './Summary/SummaryContainer';

export const BillingContent = () => {
  const billing = useAppSelector((state) => state.billing);
  const { data: cart } = useAppSelector((state) => state.cart);

  useGetAvailablePayments();
  useCheckGiftCardModals();
  useCartPayments(cart);
  useGtmEvents();

  const { isProcessingPayment } = billing || {};

  if (!isDeviceKiosco() && isProcessingPayment) {
    return <PaymentLoader />;
  }

  return (
    <ErrorBoundary FallbackComponent={FallbackBilling} onError={notifyError}>
      <main className="co-w-full co-flex co-flex-col lg:co-flex-row co-flex-1 lg:co-mx-0 co-gap-5 co-justify-center co-bg-back-gray co-mb-[190px]">
        <PaymentSection />
        <section className="co-w-full co-h-fit co-flex co-flex-col co-gap-16px lg:co-w-5/12 xl:co-w-[430px] lg:co-pr-16px">
          <SummaryContainer />
        </section>
      </main>
      <PaymentModals />
    </ErrorBoundary>
  );
};

const FallbackBilling = (props: FallbackProps): JSX.Element => (
  <ErrorFallbackBilling
    resetErrorBoundary={props.resetErrorBoundary}
    error={props.error}
  />
);
